import { axiosInstance } from 'boot/axios.js'

export async function width(ctx, queryParams = {}) {
  try {
    const response = await axiosInstance({
      url: 'width-measures',
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('width', response.data.items)
    return response
  } catch (e) {
    throw e
  }
}

export async function height(ctx, queryParams = {}) {
  try {
    const response = await axiosInstance({
      url: 'height-measures',
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('height', response.data.items)
    return response
  } catch (e) {
    throw e
  }
}

export async function rim(ctx, queryParams = {}) {
  try {
    const response = await axiosInstance({
      url: 'rim-measures',
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('rim', response.data.items)
    return response
  } catch (e) {
    throw e
  }
}

export function setWidth(ctx, data) {
  ctx.commit('setWidth', data)
}

export function setHeight(ctx, data) {
  ctx.commit('setWidth', data)
}

export function setRim(ctx, data) {
  ctx.commit('setWidth', data)
}

export async function motoWidth(ctx, queryParams = {}) {
  try {
    const response = await axiosInstance({
      url: 'motorcycles/width-measures',
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('motoWidth', response.data.items)
    return response
  } catch (e) {
    throw e
  }
}

export async function motoHeight(ctx, queryParams = {}) {
  try {
    const response = await axiosInstance({
      url: 'motorcycles/height-measures',
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('motoHeight', response.data.items)
    return response
  } catch (e) {
    throw e
  }
}

export async function motoRim(ctx, queryParams = {}) {
  try {
    const response = await axiosInstance({
      url: 'motorcycles/rim-measures',
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('motoRim', response.data.items)
    return response
  } catch (e) {
    throw e
  }
}

export function motoSetWidth(ctx, data) {
  ctx.commit('motoSetWidth', data)
}
